/**
 * Well-known ITEST product codes the UI branches on (defaults and validity checks).
 * Mirrors Database/Tables/Common/TestCodes.cs. Everything else is data from the
 * TestType table (fetched as numbers).
 */
const TestCodes = {
    Unknown: 0,
    StandardItestLeaf: 66455,
    ItestFarmerSample: 96054,
};

export default TestCodes;
